<template>
  <div id="modal_voting">
    <div class="header_modal fs_big tal_c">{{ $t("msg.voting_survey") }}</div>
    <p class="tal_c fat text_purple fs_big m13_t" v-if="step == 1">
      {{ $t("msg.dear_blu_holder") }},
    </p>
    <div class="body_modal">
      <div v-if="step == 1">
        <p class="tal_l text_grey fs_small">{{ $t("msg.voting_info_1") }}</p>
        <br />
        <p class="tal_l fs_small text_purple fat">{{ $t("msg.how_vote") }}</p>
        <p class="tal_l text_grey fs_small">{{ $t("msg.voting_info_3") }}</p>
        <br />
        <p class="tal_l text_grey fs_small">
          {{ $t("msg.contact_us_any_question") }}
        </p>
        <div class="columns tal_c">
          <div class="column">
            <button class="button-slips fat m25_t" @click="callNext()">
              {{ $t("msg.click_here_to_vote") }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="step == 2">
        <p class="tal_c fat text_purple fs_small">
          *{{ $t("msg.chose_two_coins") }}
        </p>
        <br />
        <div class="columns tal_c p0">
          <div
            class="column coins_cont"
            v-for="coin in coins"
            :key="coin.symbol"
            @click="getInfo(coin.symbol)"
            :class="
              checkedCoins[0] == coin.symbol || checkedCoins[1] == coin.symbol
                ? 'selected_coin'
                : ''
            "
          >
            <div class="columns">
              <div class="column">
                <div>
                  <div
                    :style="'height:40px; width:40px;'"
                    class="background_ icon_class_symbol"
                    :class="'background_' + coin.symbol"
                  ></div>
                </div>
              </div>
              <div class="column">
                <p>{{ coin.symbol.toUpperCase() }}</p>
              </div>
            </div>

            <!-- <div class="tal_c text_info" style="font-size:0.7rem">Since: {{ coin.date }}</div> -->
            <div
              class="column p0 m0 fs_small fat"
              :class="coin.percent > 0 ? 'green' : 'red_color'"
            >
              *{{ coin.percent }}% YTD
            </div>
          </div>
        </div>

        <div class="column fs_small tal_c m0 m20_b text_info">
          {{ $t("msg.please_chose_two_coins") }}
        </div>

        <div class="columns">
          <div
            class="column content_info text_info"
            v-for="coin in coins"
            :key="coin.symbol"
          >
            <p class="fat">{{ coin.name }}</p>
            <p style="margin-top: 10px; margin-bottom: 10px">
              <span style="font-weight: 500">{{ $t("msg.sector") }}:</span>
              {{ $t(`msg.${coin.sector}`) }} <br />
              <span style="font-weight: 500">{{ $t("msg.token_type") }}:</span>
              {{ $t(`msg.${coin.tokenType}`) }}<br />
              <span style="font-weight: 500"
                >{{ $t("msg.staking_rewards") }}:</span
              >
              {{ $t(`msg.${coin.rewards}`) }}
            </p>
            <p v-html="$t(`msg.coin_voting_${coin.symbol}`)"></p>
          </div>
        </div>

        <div class="columns tal_c">
          <div class="column">
            <button
              class="button-slips fat"
              :disabled="checkedCoins.length != 2 || buttonBlock"
              @click="postVote()"
            >
              {{ $t("msg.finish_Vote") }}
            </button>
          </div>
        </div>

        <div class="columns tal_c"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  created() {
    this.preSelectedCoins();
  },
  data: () => ({
    step: 1,
    info: "",
    checkedCoins: [],
    buttonBlock: false,
    coins: [
      {
        name: "Pancakeswap",
        symbol: "cake",
        percent: -71.27,
        sector: "decentralized_ex",
        tokenType: "bep20",
        rewards: "yes"
      },
      {
        name: "Mobox",
        symbol: "mbox",
        percent: -92.31,
        sector: "metaverse",
        tokenType: "bep20",
        rewards: "no"
      },
      {
        name: "The Sandbox",
        symbol: "sand",
        percent: -92.48,
        sector: "metaverse",
        tokenType: "erc20",
        rewards: "yes"
      },
      {
        name: "Stellar",
        symbol: "xlm",
        percent: -75.59,
        sector: "payments",
        tokenType: "native",
        rewards: "no"
      },
      {
        name: "Uniswap",
        symbol: "uni",
        percent: -69.3,
        sector: "decentralized_ex",
        tokenType: "erc20",
        rewards: "no"
      },
      {
        name: "Toncoin",
        symbol: "ton",
        percent: -30.89,
        sector: "payments",
        tokenType: "native",
        rewards: "no"
      }
    ],
    cake: 0,
    mbox: 0,
    sand: 0,
    xlm: 0,
    uni: 0,
    ton: 0
  }),
  methods: {
    preSelectedCoins() {
      this.checkedCoins.push("cake");
      this.checkedCoins.push("mbox");
    },

    getInfo(symb) {
      if (this.checkedCoins.length < 2) {
        if (this.checkedCoins.includes(symb)) {
        } else {
          this.checkedCoins.push(symb);
        }
      } else {
        if (this.checkedCoins.includes(symb)) {
        } else {
          this.checkedCoins.shift();
          this.checkedCoins.push(symb);
        }
      }
    },

    callNext() {
      this.step++;
    },

    async postVote() {
      this.buttonBlock = true;

      this.checkedCoins.forEach(element => {
        this[element]++;
      });

      let params = {
        answer: `{\"cake\":\"${this.cake}\",\"mbox\":\"${this.mbox}\",\"sand\":\"${this.sand}\",\"xlm\":\"${this.xlm}\",\"uni\":\"${this.uni}\",\"ton\":\"${this.ton}\"}`
      };

      try {
        await this.$store
          .dispatch("postSurveyPrototype", params)
          .then(this.notifySuccess(this.$t("msg.vote_success"), 3000));
      } catch (e) {
        this.notifyError(this.$t("msg.form_error"), 3000);
        this.buttonBlock = false;
      }

      setTimeout(() => {
        this.$emit("getVotingStatus");
      }, 1500);
    }
  },

  computed: {
    ...mapGetters(["bluAccount"])
  }
};
</script>
<style lang="scss" scope>
#modal_voting {
  background-color: #ffffff;
  margin-top: 5vh;
  width: 100%;
  max-width: 1100px;
  min-height: 710px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 7px;
  word-wrap: break-word;
  font-size: 20px;
  font-size: 1.2em;

  .button-slips {
    background-color: #1e2067;
    padding: 10px 30px;
    font-size: 15px;
    color: white;
    border: none;
    border-radius: 10px;
    margin-top: 20px;
    cursor: pointer;
    &:active {
      background-color: #6146ad;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .coins_cont {
    box-shadow: 0px 2px 4px #041a381a;
    margin-right: 10px;
    border-radius: 21px;
    border: 2px solid transparent;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0px;
    }

    &:active {
      background: #8a65f1;
    }
  }

  .selected_coin {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 40px #041a384d;
    border: 2px solid #c9d1ff;
    border-radius: 21px;
    opacity: 1;
  }

  .coin_info {
    background: #f3f3f3;
    border-radius: 3px;
    min-height: 76.95px;
  }

  .actived_info {
    background-color: #c5c0c0;
  }

  .icon_class_symbol {
    svg {
      width: 40px;
      height: 40px;
    }
  }

  .cont_name {
    min-height: 82px;
  }

  .green {
    color: #00b593;
  }

  .red_color {
    color: #db1f43;
  }

  .header_modal {
    background: #0966aa;
    color: white;
    min-height: 55px;
    border-radius: 7px 7px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .body_modal {
    padding: 20px 60px;
  }

  .content_info {
    border-left: solid 1px #d0d4d9;
    font-size: 13px;
    &:first-child {
      border-left: none;
    }
  }

  .text_info {
    font-weight: 300;
    color: #707070;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalVotingFourteen.vue